/**
 * Catalogue des permissions (cf. §7 du handoff backend).
 * À utiliser avec les permissions effectives renvoyées par GET /auth/me.
 */
export const PERMISSIONS = {
  // Plateforme (comptes admin). NB : les codes `*_all` et `merchants.manage`
  // ont été supprimés côté backend (migrations 007/009) — ne pas les réintroduire.
  // La distinction « mes données » / « toutes » est portée par la tenancy backend,
  // pas par une permission ; la plateforme détient les codes de base.
  PARTNERS_READ: "partners.read",
  PARTNERS_MANAGE: "partners.manage",
  CLIENTS_READ: "clients.read",
  CLIENTS_MANAGE: "clients.manage",
  CITIES_MANAGE: "cities.manage",
  STATS_READ: "stats.read",
  APIKEYS_MANAGE: "apikeys.manage",
  WEBHOOKS_MANAGE: "webhooks.manage",

  // Codes de base — détenus par la plateforme (admin) ET par les membres partenaire.
  ORDERS_READ: "orders.read",
  ORDERS_UPDATE_STATUS: "orders.update_status",
  ORDERS_BATCH_SCAN: "orders.batch_scan",
  MISSIONS_READ: "missions.read",
  MISSIONS_MANAGE: "missions.manage",
  RIDERS_READ: "riders.read",

  // Partenaire uniquement (comptes membres)
  RIDERS_MANAGE: "riders.manage",
  MEMBERS_READ: "members.read",
  MEMBERS_MANAGE: "members.manage",
  PARTNER_READ: "partner.read",
  PARTNER_MANAGE: "partner.manage",
};

/** Rôles plateforme (sélecteur de rôle admin) */
export const PLATFORM_ROLES = {
  ADMIN: "platform_admin",
  VIEWER: "platform_viewer",
};

/** Rôles partenaire (sélecteur d'invitation, cf. §4.4) */
export const PARTNER_MEMBER_ROLES = {
  OWNER: "partner_owner",
  AGENT: "partner_agent",
};

/** Statuts d'un membre partenaire (cf. §4.3) */
export const MEMBER_STATUS = {
  ACTIVE: "active",
  SUSPENDED: "suspended",
  DEACTIVATED: "deactivated",
};

// --- Lecture synchrone depuis localStorage (route/nav gating au 1er rendu) ---

export const getStoredPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions") || "[]");
  } catch {
    return [];
  }
};

export const getStoredMemberships = () => {
  try {
    return JSON.parse(localStorage.getItem("memberships") || "[]");
  } catch {
    return [];
  }
};

export const hasStoredPermission = (perm) =>
  getStoredPermissions().includes(perm);

// --- Calcul des permissions effectives à partir de la réponse /auth/me ------

/**
 * Détermine la liste de permissions effectives :
 * - compte plateforme (admin) → permissions plateforme
 * - compte partenaire → permissions de l'unique membership (règle backend
 *   « 1 membre = 1 partenaire », UNIQUE(user_id) — pas de multi-appartenance).
 */
export const computeEffectivePermissions = (me) => {
  if (!me) return [];

  if (me.platform?.permissions?.length) {
    return me.platform.permissions;
  }

  const memberships = me.partnerMemberships || [];
  return memberships[0]?.permissions || [];
};

/**
 * Persiste la session RBAC issue de /auth/me.
 * Retourne { permissions, memberships }.
 */
export const persistAuthSession = (me) => {
  const memberships = me?.partnerMemberships || [];
  const permissions = computeEffectivePermissions(me);

  localStorage.setItem("permissions", JSON.stringify(permissions));
  localStorage.setItem("memberships", JSON.stringify(memberships));

  return { permissions, memberships };
};
